<template>
  
</template>

<script>
  let buttons = ['staff:list:add'];
  let allOrgList = function() {
    return [{a:1}];
  };
  export default {
    buttons,
    allOrgList,
  };
</script>

<style scoped>

</style>
